import React from 'react'
import Home from '../components/Home'

const HomeView = ({ data, langKey }) => {
  return !!data ? <Home data={data} langKey={langKey} /> : null
}

export default HomeView
